import { render } from "./WifiOffIcon.vue?vue&type=template&id=00d60bb1&ts=true"
import script from "./WifiOffIcon.vue?vue&type=script&lang=ts"
export * from "./WifiOffIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__